import React from 'react';
import { AuthorizationsService } from '../../../../services/patientmr/authorizations.service';
import { ServiceCategory } from '../../../../dtos/patientmr/authorizations.dto';

interface SvcBadgeProps {
  serviceCategory: ServiceCategory | string;
}

export const SvcBadge: React.FC<SvcBadgeProps> = ({ serviceCategory }) => {
  const styles = AuthorizationsService.getServiceCategoryBadgeStyles(serviceCategory);
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium border ${styles}`}>
      {(serviceCategory || '').toUpperCase()}
    </span>
  );
};

export default SvcBadge;
